import React from "react";
import { motion } from "framer-motion";

const pillars = [
    { n: "01", title: "Built for commercial spaces", copy: "Every scope is designed around trading hours, staff workflow, and keeping your doors open during install." },
    { n: "02", title: "One point of contact", copy: "We plan, coordinate and install — and stay reachable once the job is done. No pass-the-parcel between vendors." },
    { n: "03", title: "Documented, not improvised", copy: "You get labelled cables, an equipment list and photos so the next technician isn't starting from scratch." },
    { n: "04", title: "Vendor-neutral by design", copy: "We work with your existing POS provider, ISP and IT support — coordinating rather than competing." },
];

export default function ValuePillars() {
    return (
        <section data-testid="value-pillars" className="border-t border-line">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-32">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
                    <div>
                        <p className="eyebrow mb-6">Why work with us</p>
                        <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight text-ink max-w-2xl">
                            One dependable partner for your business technology.
                        </h2>
                    </div>
                    <p className="text-muted max-w-sm text-sm leading-relaxed">
                        We're not a residential TV installer, a computer repair shop or an enterprise IT consultancy. We're a specialist team for commercial spaces — the crew you call when you're opening, renovating or tired of chasing vendors.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-line">
                    {pillars.map((p, i) => (
                        <motion.div
                            key={p.n}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className="border-r border-b border-line p-8 md:p-10 min-h-[280px] flex flex-col group hover:bg-bg-alt transition-colors duration-300"
                        >
                            <div className="flex items-center justify-between mb-16">
                                <span className="font-mono text-xs text-muted tracking-[0.22em]">{p.n} /</span>
                                <span className="w-1.5 h-1.5 rounded-full bg-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                            </div>
                            <h3 className="font-display text-xl md:text-2xl tracking-tight text-ink mb-3">{p.title}</h3>
                            <p className="text-sm text-muted leading-relaxed">{p.copy}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
